import * as React from "react";

function AutomotiveSvg(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={35.884}
      height={29.597}
      {...props}
    >
      <path
        d="M35.149 13.915L31.9 10.006l-4.649-8.7a2.464 2.464 0 00-2.174-1.3H10.8a2.465 2.465 0 00-2.174 1.3l-4.649 8.7-3.241 3.909A4.741 4.741 0 000 16.441v11.265a1.89 1.89 0 001.889 1.891h2.8a1.89 1.89 0 001.889-1.891v-3.557H29.3v3.558a1.89 1.89 0 001.889 1.891H34a1.89 1.89 0 001.889-1.891V16.441a4.737 4.737 0 00-.74-2.526zM7.318 7.96l2.546-5.252a2.049 2.049 0 011.842-1.159h12.472a2.047 2.047 0 011.842 1.154l2.546 5.252a.677.677 0 01-.61.972h-8.82l4.61-4.409a.36.36 0 00-.5-.517L18.1 8.93H7.927a.677.677 0 01-.609-.972zm.912 11.782H4.093a1.35 1.35 0 01-1.35-1.35c0-.745.161-2.316.9-2.243 1.162.114 3.435.682 4.584.894.839.155 1.349.6 1.349 1.349a1.35 1.35 0 01-1.346 1.35zm14.565-.514a.676.676 0 01-.643.468h-8.419a.677.677 0 01-.643-.468 18.909 18.909 0 01-.724-2.623.855.855 0 01.855-.854h9.443a.854.854 0 01.855.854 18.9 18.9 0 01-.724 2.623zm9 .514h-4.14a1.35 1.35 0 01-1.35-1.35c0-.745.511-1.194 1.35-1.349 1.149-.212 3.422-.78 4.584-.894.741-.073.9 1.5.9 2.243a1.35 1.35 0 01-1.347 1.35z"
        fill="#ff7b16"
      />
    </svg>
  );
}

export default AutomotiveSvg;
